// extracted by mini-css-extract-plugin
export default {"generate-result-recap__container":"styles_generate-result-recap__container__wtB3H"};